import { useEffect, useState } from 'react';

export const AboutHero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative bg-midnight-green overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=2070&auto=format&fit=crop"
          alt="Camp dining hall with community meals"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-midnight-green via-deep-teal/90 to-copper/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-32 md:py-40">
        <div
          className={`text-center transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          <h1 className="font-playfair text-5xl md:text-6xl lg:text-7xl font-bold text-ivory mb-6">
            Built by Camp People, for Camp People
          </h1>
          <p className="font-inter text-xl md:text-2xl text-ivory/90 max-w-3xl mx-auto leading-relaxed">
            We understand the early mornings, last-minute headcount changes, and the magic of shared meals. 
            CampChef Pro was created to make running your camp kitchen simpler, smarter, and stress-free.
          </p>
        </div>
      </div>
    </section>
  );
};
